import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LotesComponent } from './lotes/lotes.component';
import { GalponesComponent } from './galpones/galpones.component';
import { CorralesComponent } from './corrales/corrales.component';
import { AgregarCorralComponent } from './agregar-corral/agregar-corral.component';
import { PesajesComponent } from './pesajes/pesajes.component';
import { SemanaComponent } from './semana/semana.component';
import { AgregarPesoComponent } from './agregar-peso/agregar-peso.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
    { path: 'galpones', component: GalponesComponent },
    { path: 'lotes/:idgalpon', component: LotesComponent },
    { path: 'lotes', component: LotesComponent },
    { path: 'corrales/:idlote', component: CorralesComponent },
    { path: 'corrales', component: CorralesComponent },
    { path: 'agregar-corral/:idlote', component: AgregarCorralComponent },
    { path: 'agregar-corral', component: AgregarCorralComponent },
    { path: 'pesajes/:idlote/:idcorral', component: PesajesComponent },
    { path: 'pesajes', component: PesajesComponent },
    { path: 'semana/:idlote/:idcorral/:idsemana', component: SemanaComponent },
    { path: '', component: LoginComponent },
    { path: 'agregar-peso/:idlote/:idcorral', component: AgregarPesoComponent },
    { path: 'agregar-peso', component: AgregarPesoComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
